import ResetPassword from "../../components/auth/password/ResetPassword.tsx";

function ResetPasswordPage() {
    return (
        <>
            <ResetPassword />
        </>
    );
}

export default ResetPasswordPage;
